export enum ROOT_ENDPOINTS {
    CONTENT_DELIVERY = 'contentdelivery',
}
